import {Component, Inject, OnInit, Optional} from '@angular/core';
import {Compbaser} from "../compbaser";
import {TranslocoService} from "@ngneat/transloco";
import * as _ from "lodash";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-dialog-fullscreen-view',
  templateUrl: './dialog-fullscreen-view.component.html',
  styleUrls: ['./dialog-fullscreen-view.component.scss']
})

export class DialogImageFullScreenComponent extends Compbaser implements OnInit {

  resourceUrl = null;

  constructor(
    public dialogRef: MatDialogRef<DialogImageFullScreenComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) data
  ) {
    super();

    if (data) {
      this.resourceUrl = data?.url;
    }
  }

  ngOnInit(): void {

  }

  onClose() {
    this.dialogRef.close();
  }

  override destroy() {
    super.destroy();
  }
}

